import { Component, OnInit, Input } from '@angular/core';
import { Survey, SurveyAnswer } from '@fgb/core';

@Component({
  selector: 'fgb-predictor-completed-processed',
  templateUrl: './predictor-completed-processed.component.html',
  styleUrls: ['./predictor-completed-processed.component.scss', '../../../../survey.scss']
})
export class PredictorCompletedProcessedComponent implements OnInit {
  @Input() survey: Survey;
  @Input() selectedAnswers: SurveyAnswer[];
  @Input() correctAnswer: SurveyAnswer;
  @Input() hasSelectedCorrect: boolean;
  @Input() pointsWon: number;

  constructor() { }

  ngOnInit() {
  }

}
